import { Link } from "react-router-dom";
import { useState } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/solid";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <header className="bg-blue-600 text-white shadow-md fixed top-0 left-0 w-full z-50">
        <div className="max-w-screen-xl mx-auto flex items-center justify-between px-4 py-3 relative">
          {/* Logo (Center on all screens) */}
          <h1 className="text-xl font-bold mx-auto md:mx-0 md:absolute md:left-4">
            <Link to="/" onClick={() => setIsOpen(false)}>
              Build Pro Resume
            </Link>
          </h1>

          {/* Desktop Nav (centered) */}
          <nav className="hidden md:flex mx-auto space-x-6 items-center">
            <Link to="/" className="hover:underline">Home</Link>
            <Link to="/about" className="hover:underline">About Us</Link>
            <Link to="/contact" className="hover:underline">Contact</Link>
            <Link
              to="/resume"
              className="bg-white text-blue-600 font-semibold px-4 py-2 rounded-md shadow hover:bg-gray-200 transition"
            >
              Start Now
            </Link>
          </nav>

          {/* Mobile Toggle (top-right) */}
          <button
            className="md:hidden absolute right-4"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle Menu"
          >
            {isOpen ? <XMarkIcon className="w-6 h-6" /> : <Bars3Icon className="w-6 h-6" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu (Dropdown) */}
      {isOpen && (
        <nav className="md:hidden bg-blue-700 text-white w-full fixed top-[64px] z-40 shadow-lg">
          <ul className="flex flex-col items-center py-4 space-y-2">
            <li>
              <Link to="/" className="block px-4 py-2 hover:bg-blue-500 rounded" onClick={() => setIsOpen(false)}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="block px-4 py-2 hover:bg-blue-500 rounded" onClick={() => setIsOpen(false)}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/contact" className="block px-4 py-2 hover:bg-blue-500 rounded" onClick={() => setIsOpen(false)}>
                Contact
              </Link>
            </li>
            <li>
              <Link
                to="/resume"
                className="block px-4 py-2 bg-white text-blue-600 font-semibold rounded shadow hover:bg-gray-200 transition"
                onClick={() => setIsOpen(false)}
              >
                Start Now
              </Link>
            </li>
          </ul>
        </nav>
      )}

      {/* Spacer for fixed header */}
      <div className="h-[64px] md:h-[60px]"></div>
    </>
  );
}

export default Header;
